"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProspectContext = exports.ProspectStatus = void 0;
exports.ProspectContextProvider = ProspectContextProvider;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const cancelable_promise_1 = require("cancelable-promise");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const SessionContext_1 = require("./SessionContext");
const MyProfile_1 = __importDefault(require("../api/MyProfile"));
const Helper_1 = require("../Helper");
var ProspectStatus;
(function (ProspectStatus) {
    ProspectStatus[ProspectStatus["Loading"] = 0] = "Loading";
    ProspectStatus[ProspectStatus["Error"] = 1] = "Error";
    ProspectStatus[ProspectStatus["Done"] = 2] = "Done";
})(ProspectStatus || (exports.ProspectStatus = ProspectStatus = {}));
;
exports.ProspectContext = react_1.default.createContext(null);
function ProspectContextProvider(props) {
    const sessionContext = react_1.default.useContext(SessionContext_1.SessionContext);
    const prospectPromise = react_1.default.useRef(null);
    const [prospect, setProspect] = react_1.default.useState(null);
    const [prospectStatus, setProspectStatus] = react_1.default.useState(null);
    const [prospectSelectedId, setProspectSelectedId] = react_1.default.useState(null);
    react_1.default.useEffect(() => {
        if (sessionContext.userToken &&
            sessionContext.type == SessionContext_1.SessionType.Prospect) {
            if (sessionContext.onCheckSessionTimeout())
                return;
            let p = sessionContext.userToken?.claims?.prospect;
            if (p?.length > 0) {
                if (p?.length > 1 && Helper_1.Helper.isPlatformWeb) {
                    async_storage_1.default.getItem('selectedProspectId').then(v => {
                        if (v)
                            setProspectSelectedId(v);
                        else
                            setProspectSelectedId(p?.[0]);
                    }).catch(() => {
                        setProspectSelectedId(p?.[0]);
                    });
                }
                else {
                    setProspectSelectedId(p?.[0]);
                }
            }
        }
        else {
            setProspect(null);
            setProspectStatus(null);
            setProspectSelectedId(null);
        }
    }, [sessionContext.userToken]);
    react_1.default.useEffect(() => {
        if (prospectSelectedId &&
            sessionContext.type == SessionContext_1.SessionType.Prospect) {
            if (prospectSelectedId != prospect?.accountId) {
                setProspectStatus(ProspectStatus.Loading);
                if (Helper_1.Helper.isPlatformWeb) {
                    async_storage_1.default.setItem('selectedProspectId', prospectSelectedId);
                }
                prospectPromise.current = (0, cancelable_promise_1.cancelable)(MyProfile_1.default.getIntroProspect({
                    token: sessionContext?.userToken?.token,
                    prospect: prospectSelectedId
                }).then((data) => {
                    setProspect({
                        accountId: data.accountId,
                        accountName: data.accountName
                    });
                    setProspectStatus(ProspectStatus.Done);
                })).catch((e) => {
                    setProspect(null);
                    setProspectStatus(ProspectStatus.Error);
                });
            }
        }
        else {
            setProspect(null);
        }
        return () => prospectPromise.current?.cancel();
    }, [prospectSelectedId]);
    return ((0, jsx_runtime_1.jsx)(exports.ProspectContext.Provider, { value: {
            prospect, // Data for the prospect (async).
            prospectStatus, // Status of loading prospect data.
            // Get user token and selected client.
            getToken: () => Promise.resolve({
                token: sessionContext?.userToken?.token,
                prospect: prospectSelectedId
            }),
            // Change the selected prospect.
            selectProspect: (id) => setProspectSelectedId(id),
        }, children: props.children }));
}
;
